/**
 * The mark a desktop return leaves in the route state (I-1078, ADR-160 AC-29).
 *
 * On the web a return from a provider replaces the page, so every screen reads its data again. On
 * the desktop it is a client-side navigation: a screen still mounted — the profile, where a
 * provider link starts and returns — would keep what it showed before the person left. A return
 * navigates with this stamp, and such a screen reads again when it changes.
 */

const STAMP_KEY = 'desktopReturnAt';

/** The route state a desktop return navigates with. */
export function desktopReturnState(at = Date.now()): Record<string, number> {
  return { [STAMP_KEY]: at };
}

/** The stamp in a location's state, or `null` when it did not come from a desktop return. */
export function desktopReturnStampOf(state: unknown): number | null {
  if (typeof state !== 'object' || state === null) return null;
  const stamp = (state as Record<string, unknown>)[STAMP_KEY];
  return typeof stamp === 'number' ? stamp : null;
}
